import { DateUtil } from "../date/DateUtil";
/**
 * LogLevel.ts
 */
export class LogLevel {
}
/**
 * No logs will be output.
 */
LogLevel.SILENT = -1;
/**
 * Only error messages will be output.
 */
LogLevel.ERROR = 0;
/**
 * Warnings and errors will be output.
 */
LogLevel.WARN = 1;
/**
 * Debug, warnings, and errors will be output.
 */
LogLevel.DEBUG = 2;
/**
 * All logs including verbose, debug, warnings, and errors will be output.
 */
LogLevel.VERBOSE = 3;
/**
 * Logger.ts
 */
export class Logger {
    /**
     * Logs the current stack trace to the console.
     */
    static stackTrace() {
        console.trace();
    }
    /**
     * Logs the application logo and version if the log level is above SILENT.
     * @param version - The version of the application.
     */
    static logo(version) {
        if (Logger.level > LogLevel.SILENT) {
            console.log("js-core: " + version);
        }
    }
    /**
     * Logs a verbose message if the log level is VERBOSE or higher.
     * @param message - The message to log.
     */
    static verbose(message) {
        if (Logger.level >= LogLevel.VERBOSE) {
            console.log(Logger.getPrefix("VERBOSE") + message);
        }
    }
    /**
     * Logs a debug message if the log level is DEBUG or higher.
     * @param message - The message to log.
     */
    static debug(message) {
        if (Logger.level >= LogLevel.DEBUG) {
            console.log(Logger.getPrefix("DBG") + message);
        }
    }
    /**
     * Logs a warning message if the log level is WARN or higher.
     * @param message - The message to log.
     */
    static warn(message) {
        if (Logger.level >= LogLevel.WARN) {
            console.warn(Logger.getPrefix("WRN") + message);
        }
    }
    /**
     * Logs an error message if the log level is ERROR or higher.
     * @param message - The message to log.
     */
    static error(message) {
        if (Logger.level >= LogLevel.ERROR) {
            console.error(Logger.getPrefix("ERR") + message);
        }
    }
    /**
     * Forces a log message to be output regardless of the current log level.
     * @param message - The message to log.
     */
    static forceLog(message) {
        console.log(Logger.getPrefix("FORCE DBG") + message);
    }
    /**
     * Sets the log level for the Logger.
     * @param level - The new log level.
     */
    static setLogLevel(level) {
        Logger.level = level;
    }
    /**
     * Adds an object reference for debugging purposes.
     * @param obj - The object to reference.
     * @param id - An optional identifier for the object.
     */
    static addObjectRef(obj, id) {
        if (Logger.level >= LogLevel.DEBUG) {
            let refName = id;
            if ((!refName || refName === "") && obj.uiProperties) {
                refName = obj.uiProperties.id;
            }
            if (!refName || refName === "") {
                refName = obj.constructor.name;
            }
            if (this.objRef[refName] && obj.parent) {
                refName = `${obj.parent.constructor.name}.${refName}`;
            }
            if (this.objRef[refName]) {
                refName += ` (${this.objCounter})`;
            }
            this.objCounter++;
            this.objRef[refName] = obj;
            window.objRef = this.objRef;
        }
    }
    /**
     * Generates a log message prefix with the specified type and a timestamp.
     * @param type The type of the log message (e.g., "VERBOSE", "DBG").
     * @returns KOALA prefix.
     */
    static getPrefix(type) {
        return `[ KOALA:${type} ${DateUtil.timeStamp()} ] `;
    }
}
/**
 * The current log level of the Logger.
 * Messages below this level will not be logged.
 */
Logger.level = LogLevel.DEBUG;
/**
 * objRef index.
 */
Logger.objCounter = 0;
/**
 * The map of object references.
 */
Logger.objRef = {};
//# sourceMappingURL=Logger.js.map